var _opt = {
	orderStatus : {'1':'已需求','2':'已试音','3':'待支付','4':'已支付','5':'已成品','6':'已成品','8':'已成品','10':'已取消'},
	orderType : {'1':'普通','2':'修改','3':'补录','4':'保密'},
	pressingStatus : {'1':'低','2':'中','3':'高'},
    invoiceType:[
        {id:1,label:'增值税普通发票'},
        {id:2,label:'增值税专用发票'}
    ], 
    _invoiceType : {'1':'增值税普通发票','2':'增值税专用发票'},
    invoiceName : ['服务费','信息咨询费','摄影服务费'],
    invoiceStatus:{'1':'未开票','2':'已开票'},
    auditingStatus:{'1':'未审核','2':'已通过','3':'未通过'},
}

export default _opt;


// WEBPACK FOOTER //
// ./src/service/data.options.js